import React from 'react';
import Heading from 'js/components/Common/Heading/Heading';

import Filter from '../SearchFilter/SearchFilter';
import classes from './SearchSidebar.module.pcss';
import FilterReset from '../SearchFilter/SearchFilterReset/SearchFilterReset';
import {observer} from 'mobx-react';


const SearchSidebar = ({nodeRef, isAISearch}) => (
    <aside className={`${classes.SearchSidebar}` }>
        <div className={classes.Wrap}>
            <Heading text={'Filters'} type={'h4'} />
            <FilterReset nodeRef={nodeRef} isAISearch={isAISearch} />
        </div>
        <Filter />
    </aside>
);

export default observer(SearchSidebar);
